import { REPORT_DATA_FAILURE, REPORT_DATA_SUCCESS } from "./report.actionTypes";


const initialState = {
  reportDataArray: null,
};

export default function reportReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case REPORT_DATA_SUCCESS:
      return {
        ...state,
        reportDataArray: payload,
      };
    case REPORT_DATA_FAILURE:
      return {
        ...state,
        message: "",
      };


    default:
      return state;
  }
}
